import type { TimelineItemWithSegment, TimelineSegment } from './timeline-interfaces';
import type { ZoomableTimelineOps } from '@mimir/client-common/timeline/zoomableTimelineOps';

export default class TimelineItem implements TimelineItemWithSegment {

  public static readonly MIN_ITEM_WIDTH = 2;
  public static readonly MIN_DURATION = 500;

  public isResizingLeft: boolean | null = null;


  constructor(
    private item: TimelineSegment,
    private setTime: (ms: number) => void,
    private zoomableTimeline: ZoomableTimelineOps
  ) {}

  onDrag(durationInMs: number, x: number) {
    const startMs = this.zoomableTimeline.pixelToTime(durationInMs, x);
    this.setTimespan(durationInMs, startMs, startMs + this.duration);
  }


  onResizeLeft(durationInMs: number, x: number) {
    const startMs = this.zoomableTimeline.pixelToTime(durationInMs, x);
    this.setTimespan(durationInMs, startMs, this.item.endMs);
  }

  onResizeRight(durationInMs: number, w: number) {
    const newDur = this.zoomableTimeline.pixelToTime(durationInMs, w);
    const startMs = this.item.startMs;
    this.setTimespan(durationInMs, startMs, startMs + newDur);
  }

  setTimespan(durationInMs: number, startMs: number, endMs: number) {
    const dur = Math.max(endMs - startMs, TimelineItem.MIN_DURATION);
    this.item.startMs = this.sanitizeStartTime(durationInMs, startMs);
    this.item.endMs = this.sanitizeEndTime(durationInMs, startMs + dur);
    const shouldSyncWithStartTime = (this.isResizingLeft !== null && this.isResizingLeft) || this.isResizingLeft === null;
    this.setTime(shouldSyncWithStartTime ? this.item.startMs : this.item.endMs);
  }

  get timelineSegment() {
    return this.item;
  }

  get duration() {
    return (this.item.endMs - this.item.startMs) || TimelineItem.MIN_DURATION;
  }

  getLeft(durationInMs: number) {
    return this.zoomableTimeline.timeToPixel(durationInMs, this.item.startMs);
  }

  getWidth(durationinMs: number) {
    const result = this.zoomableTimeline.timeToPixel(durationinMs, this.duration);
    return Math.max(result, TimelineItem.MIN_ITEM_WIDTH);
  }

  getMinWidth(durationInMs: number) {
    return Math.max(this.zoomableTimeline.timeToPixel(durationInMs, TimelineItem.MIN_DURATION), TimelineItem.MIN_ITEM_WIDTH);
  }

  getMaxWidth() {
    return this.zoomableTimeline.timelineWidth;
  }

  sanitizeStartTime(durationInMs: number, ms: number) {
    let sanitized = Math.max(ms, 0);
    sanitized = Math.min(sanitized, durationInMs - TimelineItem.MIN_DURATION);
    return sanitized;
  }

  private sanitizeEndTime(durationInMs: number, ms: number) {
    let sanitized = Math.max(ms, TimelineItem.MIN_DURATION);
    sanitized = Math.min(sanitized, durationInMs);
    return sanitized;
  }

}
